import type { StateCreator } from 'zustand';
import type { FlowMedia } from '@/types';

export interface ResultSlice {
  resultFile: FlowMedia | null;
  setResultFile: (file: FlowMedia | null) => void;
  generationTimestamp: number | null;
  setGenerationTimestamp: (timestamp: number | null) => void;
  localNotification: FlowMedia | null;
  setLocalNotification: (file: FlowMedia | null) => void;
}

export const resultInitialState = {
  resultFile: null as FlowMedia | null,
  generationTimestamp: null as number | null,
  localNotification: null as FlowMedia | null,
};

export const createResultSlice: StateCreator<
  ResultSlice,
  [],
  [],
  ResultSlice
> = (set) => ({
  ...resultInitialState,

  setResultFile: (resultFile) => set({ resultFile }),
  setGenerationTimestamp: (generationTimestamp) => set({ generationTimestamp }),
  setLocalNotification: (localNotification) => set({ localNotification }),
});
